import { cFormat } from 'utils'

export default function install(Vue){
    Vue.filter('FMathmin', function(it, key = 'odds', limit = true, index = 3) {
        const _the = limit ? '_' : ''
        if(!it[key]) return
        const min  =  Math.min(it[key], it[`${key}${_the}2`], it[`${key}${_the}3`]).toFixed(index)
        return  min 
    })
    Vue.filter('commaFormat', cFormat)
    Vue.prototype.$commaFormat = (val) => cFormat(val)
}
